import axios from 'axios';

export const candidateLibraryApi = {
  list(params = {}) {
    const { page = 1, limit = 25, q } = params;
    return axios
      .get('/api/job-posts/candidate-library', {
        params: {
          page,
          limit,
          q,
        },
      })
      .then((res) => res.data);
  },
};
